import React from 'react';
import { Link } from 'react-router-dom';
import AgendaListItemIcon from '../agendaListItemIcon/agendaListItemIcon';
import AgendaListTitle from '../agendaListTitle/agendaListTitle';
import IconTooltip from '../iconTooltip/iconTooltip';
import styles from './styles.css';

const AgendaItemSummary = ({ event }) => {
  return (
    <Link to={`/lots/${event.resource.lotId}`} className="db flex pv2 items-center">
      <AgendaListItemIcon event={event} />
      <div className="flex-grow-1">
        <AgendaListTitle {...event} />
      </div>
      <IconTooltip text="View lot" className={`${styles.icon} mr2 rotate-180`} icon="chevron-left" />
    </Link>
  );
};

export default AgendaItemSummary;



// WEBPACK FOOTER //
// ./src/components/agendaItemSummary/agendaItemSummary.jsx